import { render, staticRenderFns } from "./TodoGroupList.vue?vue&type=template&id=3d757892&"
import script from "./TodoGroupList.vue?vue&type=script&lang=ts&"
export * from "./TodoGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports